module.exports = __webpack_public_path__ + "static/media/a7.c5d93229.jpg";